const React = require('react')

module.exports = { 
      attributes: {"title":"The Big Island's source for welding, fabrication and repair","subtitle":"Specializing in steel, stainless steel and aluminum fabrication","quoteRequestLabel":"Request a free estimate","quoteRequestEmail":"solidmetalworks808@gmail.com","quoteRequestSubject":"SMW Quote Request","phoneNumber":"808.365.4805","address":"73-5583 Maiau St / Kailua Kona, HI, 96740 / United States","facebookUrl":"https://facebook.com/solidmetalworks","instagramUrl":"https://instagram.com/solidmetalworks","seoTitle":"Welding, Fabrication, & Repair in Kona, HI | Solid Metal Works","seoDescription":"The Big Island’s source for welding, fabrication and repair, specializing in steel, stainless steel and aluminum fabrication","images":["/img/img_1481.jpg","/img/img_1507.jpg","/img/img_0958.jpg","/img/img_1732.jpg","/img/img_1239.jpg","/img/img_1922.jpg"]},
    
      react: 
      function (props) {
        Object.keys(props).forEach(function (key) {
          this[key] = props[key]
        })
        const markdown = /*#__PURE__*/React.createElement("div", {
  className: "frontmatter-markdown"
});
        return markdown
      }
    ,
     }